import { createSelector } from 'reselect';
import { changeSelectedLayout } from '../../../utilities/change-selected-layout.esm.js';
import { getLockedFields } from '../../../utilities/get-locked-fields.esm.js';

var getChangeLayoutFunction = function getChangeLayoutFunction(layouts, resources, lockedFields) {
  return function (selection) {
    var id = selection.id,
      type = selection.type;
    return changeSelectedLayout(resources.layouts, lockedFields)(layouts, id, type);
  };
};
function getChangeLayoutCallback(allFields, layouts, displayLayouts, setDisplayLayouts, resources) {
  var lockedFields = getLockedFields(allFields);
  var getChangeLayout = getChangeLayoutFunction(layouts, resources, lockedFields);
  return function (_event, value, reason) {
    if (!value) {
      return;
    }
    if (reason !== 'selectOption') {
      return;
    }
    var newValue = getChangeLayout(value);
    if (newValue !== displayLayouts) {
      setDisplayLayouts(newValue);
    }
  };
}
var createChangeLayoutCallbackSelector = function createChangeLayoutCallbackSelector() {
  return createSelector(function (value) {
    return value.allFields;
  }, function (value) {
    return value.layouts;
  }, function (value) {
    return value.displayLayouts;
  }, function (value) {
    return value.setDisplayLayouts;
  }, function (value) {
    return value.resources;
  }, getChangeLayoutCallback);
};

export { createChangeLayoutCallbackSelector };
//# sourceMappingURL=change-layout-callback-selector.esm.js.map
